'use client';

import { IStepsBlock } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import React from 'react';
import AnimatedTitle from '../../components/AnimatedTitle';
import styles from './HowWeWork.module.scss';
import HowWeWorkItem from './HowWeWorkItem';
import HowWeWorkContactButton from './HowWeWorkContactButton';

export default function HowWeWork({ data }: { data: IStepsBlock }) {
  return (
    <section className={classnames(styles.howWeWork, 'container')}>
      <div className={styles.howWeWork__info}>
        <h2 className={classnames(styles.howWeWork__title, 'sectionTitle')}>
          <AnimatedTitle title={data.title} />
        </h2>
        <p className={styles.howWeWork__subtitle}>
          {data.description}
        </p>
        <HowWeWorkContactButton ctaButton={data.ctaButton} />
      </div>
      <div className={styles.howWeWork__content}>
        {data.development_processes.map(item => (
          <HowWeWorkItem
            key={item.id}
            icon={item.image}
            title={item.title}
            text={item.description}
          />
        ))}
      </div>
    </section>
  );
}
